import "@fontsource/vazirmatn/400.css";
import "@fontsource/vazirmatn/500.css";
import "@fontsource/vazirmatn/600.css";
import { useEffect } from "react";
import NoorinHome from "../noorin/NoorinHome";
import { LangProvider } from "../noorin/i18n/LangContext";
import "./NewNoorinHomePreview.css";

export default function NewNoorinHomePreview() {
  useEffect(() => {
    document.documentElement.classList.add("noorin-preview-open");
    document.body.classList.add("noorin-preview-open");
    return () => {
      document.documentElement.classList.remove("noorin-preview-open");
      document.body.classList.remove("noorin-preview-open");
    };
  }, []);

  return (
    <div className="noorin-preview-shell">
      <LangProvider>
        <NoorinHome />
      </LangProvider>
    </div>
  );
}
